// Shared FAQ content — used by the FAQ section and the FAQPage JSON-LD on the homepage.
export type FaqItem = { q: string; a: string }

export const FAQS: FaqItem[] = [
  {
    q: "Do you share pricing?",
    a: "There's no public pricing. The partnership is tailored to your show and goals, so we qualify fit and budget privately through the application, then discuss specifics together on the Fit Call.",
  },
  {
    q: "How long is the partnership?",
    a: "Six months — long enough to build real momentum in your positioning, guest relationships, and a growing library of trust-rich content rather than a quick burst that fades. At the end of the engagement, you can choose to renew for another six-month partnership to keep that momentum compounding.",
  },
  {
    q: "Do episodes have to be video?",
    a: "Video is included by default. It produces the most flexible, repurposable content and the strongest authority signal across the platforms your audience already uses.",
  },
  {
    q: "What do you handle, and what do I handle?",
    a: "We build the strategy, guest pipeline intelligence, interview preparation, production, and content multiplication. You own the relationships — approving guests, sending invitations, and following up — because those are strongest coming from you.",
  },
  {
    q: "Is this for a brand-new show or an existing one?",
    a: "Both. We help new shows start with the right foundation, and we reposition existing shows for stronger structure, better guest strategy, and clearer business alignment.",
  },
  {
    q: "What exactly is a Fit Call?",
    a: "A focused conversation to look at your offer, audience, and current authority position, and to decide together whether a podcast-led relationship strategy makes sense for your business. It's not a pitch.",
  },
]
